export const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/windows/i.test(userAgent)) {
        return "Windows";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/linux/i.test(userAgent)) {
        return "Linux";
    }

    if (/iphone|ipad|ipod/i.test(userAgent)) {
        return "iOS";
    }

    if (/macintosh|mac os x/i.test(userAgent)) {
        return "MacOS";
    }

    return "Unknown";
};

export const loginRegistrationAdditionalHeaders = () => {
    let platform = 'web';
    const mobileOperatingSystem = getMobileOperatingSystem().toLowerCase();
    if (mobileOperatingSystem === 'android') {
        platform += '-android';
    } else if (mobileOperatingSystem === 'ios') {
        platform += '-ios';
    }

    return {
        'x-platform': platform
    };
};
